export default __webpack_public_path__ + "static/artboard-45-bacbe0317ddf5953f351c5725c78ca0e.png";